import { AppLink } from "../foundations/AppLink.js";
import { cn } from "../foundations/cn.js";
import { FOCUS_RING } from "../foundations/interaction.js";

export interface BreadcrumbProps {
  /** From the top level down; the last item is the current page and has no link. */
  items: readonly { label: string; href?: string }[];
  label?: string;
  className?: string;
}

/** Where the page sits: Boxes / Tide Pool. */
export function Breadcrumb({ items, label = "Breadcrumb", className }: BreadcrumbProps) {
  return (
    <nav aria-label={label} className={className}>
      <ol className="flex flex-wrap items-center gap-1.5 font-body text-body-b3 text-text-tertiary">
        {items.map((item, index) => {
          const last = index === items.length - 1;
          return (
            <li key={`${item.href ?? ""}${item.label}`} className="flex items-center gap-1.5">
              {last || !item.href ? (
                <span
                  aria-current={last ? "page" : undefined}
                  className={cn(last && "text-text-secondary")}
                >
                  {item.label}
                </span>
              ) : (
                <AppLink
                  href={item.href}
                  className={cn("rounded-xs hover:text-text-primary", FOCUS_RING)}
                >
                  {item.label}
                </AppLink>
              )}
              {!last && <span aria-hidden>/</span>}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
